export enum ContractPriceStripTimeModel {
  'anytime' = 'anytime',

  'peak_off_peak' = 'peak_off_peak',

  'supplier_calendar_market_peak_off_peak' = 'supplier_calendar(MARKET_PEAK_OFF_PEAK)',
}
